import { GridFilterItem } from '@rossum/ui/x-data-grid-pro';
import { snakeToCamel } from '../../../lib/keyConvertor';
import {
  dateToQuery,
  isDateOperator,
} from '../../document-list-filtering/dateUtils';

const resolveDateOperator = (operator: string) =>
  ({ onOrBefore: 'before', onOrAfter: 'after' })[operator] || operator;

const firstStringToUpperCase = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const encodeEmailsFiltering = (filterItems: GridFilterItem[]) =>
  filterItems.reduce((acc, { field, operator, value }) => {
    if (isDateOperator(operator)) {
      const dateOperator = resolveDateOperator(operator);
      return {
        ...acc,
        // api for emailThreads filtering uses combination of field name and operator to determine the date filter
        [`${snakeToCamel(field)}${firstStringToUpperCase(dateOperator)}`]:
          dateToQuery(new Date(value)),
      };
    }

    if (field === 'options' && Array.isArray(value)) {
      return {
        ...acc,
        ...value.reduce<Record<string, true>>((accResult, optionValue) => {
          return { ...accResult, [`${optionValue}`]: true };
        }, {}),
      };
    }

    return acc;
  }, {});
